import {
  LoyaltyEngineId,
  SanityOfferListItemWithExtras,
  SanitySystemwideTierGroup,
  isSanityOfferListItemWithExtras,
  isSanitySystemwideTierGroup,
} from 'state/loyalty/types';

type OfferToTierGroupMap = Record<LoyaltyEngineId, SanitySystemwideTierGroup>;

export function mapOffersToTierGroup(offers: SanityOfferListItemWithExtras[]): OfferToTierGroupMap {
  const map: OfferToTierGroupMap = {};
  const tierGroups = offers.filter(isSanitySystemwideTierGroup);

  for (const tierGroup of tierGroups) {
    const offers = tierGroup.offers ?? [];
    for (const offer of offers) {
      if (!isSanityOfferListItemWithExtras(offer) || !offer?.loyaltyEngineId) {
        continue;
      }

      map[offer.loyaltyEngineId] = tierGroup;
    }
  }

  return map;
}
